import axios from 'axios';

const USER_KEY = 'currentUser';
const ROLE_KEY = 'currentUserRole';
const ADMIN_ROLES = new Set(['Admin', 'Super Admin']);

axios.defaults.withCredentials = true;

export function storeSession(user, session) {
  const identity = user?.email || user?.username;

  if (!identity) {
    throw new Error('Login response did not include a user identity');
  }

  localStorage.setItem(USER_KEY, identity);
  localStorage.setItem(
    ROLE_KEY,
    session?.scope === 'admin' && ADMIN_ROLES.has(user.role)
      ? user.role
      : 'User'
  );
}

export function clearSession() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(ROLE_KEY);
}

export function hasAdminSession() {
  return Boolean(
    localStorage.getItem(USER_KEY)
    && ADMIN_ROLES.has(localStorage.getItem(ROLE_KEY))
  );
}

export async function endSession() {
  clearSession();

  try {
    await axios.post('/api/xapi', { action: 'logout' });
  } catch (error) {
    console.warn('The local session was cleared, but server logout failed:', error.message);
  }
}

export function installSessionInterceptor() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const isUnauthorized = error.response?.status === 401;
      const publicPaths = new Set(['/login', '/admin-login', '/reset-password']);

      if (isUnauthorized && !publicPaths.has(window.location.pathname)) {
        const wasAdmin = ADMIN_ROLES.has(localStorage.getItem(ROLE_KEY));
        clearSession();
        window.location.assign(wasAdmin ? '/admin-login' : '/login');
      }

      return Promise.reject(error);
    }
  );
}
